import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../auth";
import { useUniversalSearchOptional } from "../../../context/UniversalSearchContext";
import {
  openSearchViaHeaderButton,
  shouldOpenSearchFromShortcut,
  shouldRefocusSearchInputFromShortcut,
} from "./universalSearchShortcutUtils";

/**
 * Global keyboard shortcut to open Universal Search: Ctrl/Cmd + /.
 * Uses UniversalSearchProvider when available; falls back to header button click.
 */
const UniversalSearchShortcutHandler: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();
  const universalSearch = useUniversalSearchOptional();

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (
        shouldRefocusSearchInputFromShortcut({
          isAuthenticated,
          pathname,
          event,
        })
      ) {
        universalSearch?.focusSearchInput();
        return;
      }

      if (
        !shouldOpenSearchFromShortcut({
          isAuthenticated,
          pathname,
          event,
        })
      ) {
        return;
      }

      if (universalSearch) {
        universalSearch.openSearch();
        window.setTimeout(() => universalSearch.focusSearchInput(), 0);
        return;
      }

      openSearchViaHeaderButton();
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isAuthenticated, pathname, universalSearch]);

  return null;
};

export default UniversalSearchShortcutHandler;
